/* eslint-disable no-restricted-globals */
import React, { useEffect } from 'react';
import { useStores } from 'util/mobx/stores';
import { observer } from 'mobx-react';
import PackageDetailRightMenu from './PackageDetailRightMenu';
import PackageDetailForm from './PackageDetailForm';

const InstrumentDetail = observer(() => {
  const { instrumentStore, appNavigationStore } = useStores();

  // set the component for the right menu
  useEffect(() => {
    appNavigationStore.setRightMenuBuilder(() => {
      return <PackageDetailRightMenu />;
    });
  }, [appNavigationStore]);

  appNavigationStore.useSubPageIdSetter('detail');

  if (instrumentStore.fullPackageItem) {
    return <PackageDetailForm packageDetail={instrumentStore.fullPackageItem} />;
  }
  return null;
});

export default InstrumentDetail;
